import { SITE_TEXT_PRESETS, SITE_COLORS } from "./theme.js";
const getStyle = (style) => ({
  ...style,
  styleParams: {
    colors: style?.styleParams?.colors ?? {},
    booleans: style?.styleParams?.booleans ?? {},
    numbers: style?.styleParams?.numbers ?? {},
    fonts: style?.styleParams?.fonts ?? {},
    googleFontsCssUrl: ""
  },
  siteColors: SITE_COLORS,
  siteTextPresets: SITE_TEXT_PRESETS
});
export {
  getStyle
};
//# sourceMappingURL=get-style.js.map
